import { render, staticRenderFns } from "./PhotographicProductionDataTable.vue?vue&type=template&id=50d5da06&scoped=true&"
import script from "./PhotographicProductionDataTable.vue?vue&type=script&lang=js&"
export * from "./PhotographicProductionDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5da06",
  null
  
)

export default component.exports